import {memo} from 'react';

import type {SVGProps} from 'react';

export const AccountCardIcon = memo(function AccountCardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={22}
      height={15}
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.5}
        y={0.5}
        width={21}
        height={14}
        rx={2.5}
        fill="var(--icon-fill-slate)"
        stroke="var(--icon-stroke-slate)"
      />
      <rect x={1} y={3} width={20} height={3} fill="var(--icon-stroke-slate)" />
      <rect x={13} y={10} width={6} height={2} rx={1} fill="var(--icon-stroke-slate-strong)" />
    </svg>
  );
});
